import { Modal, Text, ActionButton } from "components/commons";
import React from "react";
import styles from "./confirm-modal.module.scss";
import classNames from "classnames";

const ConfirmModal = ({
  content = "",
  contentStyle,
  loading: loadingState,
  primary,
  secondary,
  centerActions,
  actions = [],
  children,
  disabled: disableButtonState,
  hideActions = false,
  hidePrimary = false,
  hideSecondary = false,
  ...state
}) => {
  const {
    text: primaryText = "Got It",
    loading,
    onClick: primaryOnClick = () => {
      state.close();
    },
  } = primary || {};

  const {
    text: secondaryText = "Cancel",
    onClick: secondaryClick = () => {
      state.close();
    },
  } = secondary || {};
  return (
    <Modal {...state}>
      <div className={classNames(styles.container)}>
        <Text className={classNames(styles.content, contentStyle)}>{content}</Text>
      </div>
      {children}
      {!hideActions && (
        <ActionButton
          right={secondary}
          center={centerActions || (!hideSecondary && !secondary)}
          items={[
            ...actions,
            ...(!hideSecondary && secondary
              ? [
                  {
                    disabled: disableButtonState,
                    onClick: () => {
                      secondaryClick();
                      state.close();
                    },
                    text: secondaryText,
                    primary: false,
                  },
                ]
              : []),
            ...(!hidePrimary
              ? [
                  {
                    ...primary,
                    onClick: () => {
                      primaryOnClick();
                    },
                    text: primaryText,
                    primary: true,
                    loading: loading || loadingState,
                  },
                ]
              : []),
          ]}
        />
      )}
    </Modal>
  );
};

export default ConfirmModal;
